import HtmlContainer from 'views/pages/html/HtmlContainer';

export default HtmlContainer;
